import React, { ReactNode } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  Tooltip,
  IconButton
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import { rupeesDisplayFull } from "../../../../helpers/util";
import { TSalarySummary } from "../../../../interfaces/SalaryInterface";

interface PropType {
  salarySummary: TSalarySummary;
}

function AnnualGrossTaxablIncome({ salarySummary }: PropType): ReactNode {
  return (
    <div>
      <Box>
        <Typography>Annual Gross Taxable Income</Typography>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: "none", border: "1px solid", borderColor: "divider" }}
        >
          <Table size="small">
            <TableBody>
              {/* current month taxable income */}
              <TableRow>
                <TableCell>
                  Current Month Taxable Income
                  <Tooltip title=" Monthly Taxable Income = Monthly Gross Salary + Bonuses - Deductions">
                    <IconButton size="small" sx={{ ml: 0.5 }}>
                      <InfoIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  {rupeesDisplayFull(salarySummary?.taxableIncome?.currentMonthTaxableIncome ?? 0)}
                </TableCell>
              </TableRow>

              {/* past taxable income */}
              <TableRow>
                <TableCell>
                  Past Months Taxable Income Total
                  <Tooltip title="Sum of all the taxable income of past months in current fiscal year.">
                    <IconButton size="small" sx={{ ml: 0.5 }}>
                      <InfoIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  {rupeesDisplayFull(salarySummary?.taxableIncome?.pastTaxableIncomeTotal ?? 0)}
                </TableCell>
              </TableRow>

              {/* projected taxable income */}
              <TableRow>
                <TableCell>
                  Future Taxable Income Total
                  <Tooltip title="Sum of all the taxable income of future months in current fiscal year. Calculated from CTC.">
                    <IconButton size="small" sx={{ ml: 0.5 }}>
                      <InfoIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  {rupeesDisplayFull(salarySummary?.taxableIncome?.futureTaxableIncomeTotal ?? 0)}
                </TableCell>
              </TableRow>

              {/* annual value */}
              <TableRow sx={{ fontWeight: 600, color: "#43a047" }}>
                <TableCell
                  sx={(theme) => ({
                    color: theme.palette.primary.main,
                    fontWeight: 600
                  })}
                >
                  Annual Gross Taxable Income
                </TableCell>
                <TableCell
                  sx={(theme) => ({
                    textAlign: "right",
                    color: theme.palette.primary.main,
                    fontWeight: 600
                  })}
                >
                  {rupeesDisplayFull(salarySummary?.taxableIncome?.annualGrossTaxableIncome)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}

export default AnnualGrossTaxablIncome;
